import { render } from "./ScheduleLocEmailModal.vue?vue&type=template&id=ea20acec&scoped=true"
import script from "./ScheduleLocEmailModal.vue?vue&type=script&lang=js"
export * from "./ScheduleLocEmailModal.vue?vue&type=script&lang=js"

import "./ScheduleLocEmailModal.vue?vue&type=style&index=0&id=ea20acec&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea20acec"]])

export default __exports__